import { render, staticRenderFns } from "./PaginacionListado.vue?vue&type=template&id=1998b932&scoped=true"
import script from "./PaginacionListado.vue?vue&type=script&lang=js"
export * from "./PaginacionListado.vue?vue&type=script&lang=js"
import style0 from "./PaginacionListado.vue?vue&type=style&index=0&id=1998b932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998b932",
  null
  
)

export default component.exports